import type { ToolbarPosition } from "types/preview";

export function calculateToolbarPosition(
  toolbarPosition: ToolbarPosition,
  { width: widthOffset, height: heightOffset }: DOMRect,
): { top: number; left: number } {
  const { innerHeight, innerWidth } = window;
  const defaultStyle = { x: 0, y: 0, visibility: "visible" };
  const margin = 22;

  if (toolbarPosition === "TOP_LEFT") {
    return { ...defaultStyle, top: 0, left: 0 };
  }

  if (toolbarPosition === "BOTTOM_LEFT") {
    return {
      ...defaultStyle,
      top: innerHeight - heightOffset - margin * 2,
      left: 0,
    };
  }

  if (toolbarPosition === "BOTTOM_RIGHT") {
    return {
      ...defaultStyle,
      top: innerHeight - heightOffset - margin * 2,
      left: innerWidth - widthOffset - margin * 2,
    };
  }

  // "TOP_RIGHT"
  return {
    ...defaultStyle,
    top: 0,
    left: innerWidth - widthOffset - margin * 2,
  };
}

export const setOverlayPosition = (
  event: MouseEvent | TouchEvent | PointerEvent,
): ToolbarPosition | undefined => {
  const { clientX, clientY } = event as MouseEvent;
  const { innerHeight, innerWidth } = window;

  // Right
  if (clientX > innerWidth / 2) {
    // Bottom
    if (clientY > innerHeight / 2) {
      return "BOTTOM_RIGHT";
    } else {
      // Top
      return "TOP_RIGHT";
    }
  } else {
    // Bottom
    if (clientY > innerHeight / 2) {
      return "BOTTOM_LEFT";
    } else {
      // Top
      return "TOP_LEFT";
    }
  }
};

const LOCALHOST_KEY = "CSB_ISOLATED_PREVIEW_TOOLBAR_POSITION";

export const getClientPreference = (): ToolbarPosition => {
  if (typeof window === "undefined") return "BOTTOM_LEFT";
  /* eslint-disable-next-line no-restricted-properties */
  const preference = window.localStorage.getItem(
    LOCALHOST_KEY,
  ) as ToolbarPosition;

  return preference || "BOTTOM_LEFT";
};

export const setClientPreference = (value: ToolbarPosition): void => {
  if (typeof window === "undefined") return;
  /* eslint-disable-next-line no-restricted-properties */
  window.localStorage.setItem(LOCALHOST_KEY, value);
};
